module.exports = __webpack_public_path__ + "static/media/8-2.2d05c35e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/8-2.png
// module id = 1688
// module chunks = 0 1